"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyEmail = verifyEmail;
const baseUrls_1 = require("./baseUrls");
const fetchWrapper_1 = require("./fetchWrapper");
async function verifyEmail(token) {
    const url = `${baseUrls_1.AuthApiBaseUrl}/verifyEmail?token=${token}`;
    const verifyEmailResponse = await (0, fetchWrapper_1.fetchWrapper)(url, { method: 'GET' });
    return verifyEmailResponse.data;
}
